import { sortBySequenceNumber } from 'shared/lib/common-util'
import { fromDocumentResponse } from '../../document/models/responseToModel'
import { DocumentCreate } from '../../document/models/request'
import { Document } from '../../document/models/types'
import { toCreateDocumentRequests } from '../models/mapper'
import { createConsignmentDocumentsV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createConsignmentDocuments(
  transitOperationId: number,
  consignmentId: number,
  documents: DocumentCreate[],
): Promise<Document[]> {
  const requests = toCreateDocumentRequests(documents, transitOperationId, consignmentId)
  if (requests.length === 0) {
    return []
  }

  const responses = await createConsignmentDocumentsV3(consignmentId, requests)
  return responses.map((r, i) => fromDocumentResponse(r, i)).sort(sortBySequenceNumber)
}
